import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";

const AddAssetsModal = ({ modal, toggle, modalData, GetAssetsList }) => {
  // console.log("modalData>>>>>>>>",modalData);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (modalData) {
      reset({
        name: modalData?.name,
      });
    }
  }, [modalData, reset]);

  const closeHandler = () => {
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const submitData = {
      name: data?.name,
    };
    // console.log("submitData>>>>.", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };
    if (modalData?.id) {
      let API = apiUrl?.add_asset + `?assetId=${modalData?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          GetAssetsList();
          closeHandler();
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      let API = apiUrl?.add_asset;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          GetAssetsList();
          closeHandler();
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
      isOpen={modal}
      toggle={closeHandler}
      centered
    >
      <ModalHeader toggle={closeHandler}>
        <h3>{modalData?.id ? "Update" : "Add"} Assets</h3>
      </ModalHeader>

      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className="text-center p-4">
          <div className="modal-content">
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="erning" className="form-label">
                    Asset Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Asset Name"
                    {...register("name", {
                      required: "This field is Required",
                    })}
                  />
                </div>
                <ErrorMessage message={errors?.name?.message} />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeHandler}
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            {isLoading ? <Spinner /> : modalData?.id ? "Update" : "Add"}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddAssetsModal;
